import React from "react";
import Slider from 'react-slick';
import WorldMap from "../../common/react-world-map";

function OverView(props) {
    return (
        <React.Fragment>
            <div className="row mt-xl-5 pt-xl-5 pt-lg-4 pt-3 mt-3 mb-5 justify-content-center align-items-center">
                <div className="col-lg-5 col-md-4 col-12 text-md-start text-center">
                    <h1 className='ff-ember-lt'>It's not just Online TV<br/>It's the Future</h1>
                    <h5 className='ff-ember-lt w-100'>Extend your Reach to a Multicultural Audience with our diversified Targeting Techniques and Affable Ad Options</h5>
                    <button className='btn btn-primary btn-lg px-3 mt-xl-4 mt-lg-3 mt-2' onClick={() => props.setIndex("pills-advertise-us-tab")}>Advertise with us</button>
                </div>
                <div className="col-md-7 col-12 mt-lg-0 mt-5">
                    <Slider
                        centerMode={true}
                        dots={true}
                        arrows={false}
                        slidesToShow={1}
                        slidesToScroll={1}
                        centerPadding="100px"
                    >
                        <img src="https://yuppstatic.akamaized.net/yupptv/yupptv_new/Web/minified/Content/images/advertise/tv.png" className="w-100" />
                        <img src="https://yuppstatic.akamaized.net/yupptv/yupptv_new/Web/minified/Content/images/advertise/iphone.png" className="w-100" />
                        <img src="https://yuppstatic.akamaized.net/yupptv/yupptv_new/Web/minified/Content/images/advertise/laptop.png" className="w-100" />
                    </Slider>
                </div>
            </div>
            <div className="row justify-content-center mt-xl-5 mt-5 pt-lg-5 pt-2">
                <div className="col-md-6 col-11">
                    <div className="row text-md-start text-center">
                        <div className="col-6 my-4">
                            <div className="d-flex flex-md-row flex-column justify-content-md-start justify-content-center">
                                <div className='me-xxl-5 me-lg-4 me-md-3 me-2'>
                                    <button className='btn btn-warning rounded-pill'>
                                        <i className='bi bi-book display-6'/>
                                    </button>
                                </div>
                                <div className='text-md-start text-center mt-md-0 mt-4'>
                                    <h2 className='ff-ember-rg'>1.5 Billion</h2>
                                    <h6 className='ff-ember-lt'>View minutes per month</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 my-4">
                                <div className="d-flex flex-md-row flex-column justify-content-start">
                                <div className='me-xxl-5 me-lg-4 me-md-3 me-2'>
                                    <button className='btn btn-warning rounded-pill'>
                                        <i className='bi bi-book display-6'/>
                                    </button>
                                </div>
                                <div className='text-md-start text-center mt-md-0 mt-4'>
                                    <h2 className='ff-ember-rg'>100%</h2>
                                    <h6 className='ff-ember-lt'>Viewability</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 my-4">
                                <div className="d-flex flex-md-row flex-column justify-content-start">
                                <div className='me-xxl-5 me-lg-4 me-md-3 me-2'>
                                    <button className='btn btn-warning rounded-pill'>
                                        <i className='bi bi-book display-6'/>
                                    </button>
                                </div>
                                <div className='text-md-start text-center mt-md-0 mt-4'>
                                    <h2 className='ff-ember-rg'>90%</h2>
                                    <h6 className='ff-ember-lt'>Completion Rate</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 my-4">
                                <div className="d-flex flex-md-row flex-column justify-content-start">
                                <div className='me-xxl-5 me-lg-4 me-md-3 me-2'>
                                    <button className='btn btn-warning rounded-pill'>
                                        <i className='bi bi-book display-6'/>
                                    </button>
                                </div>
                                <div className='text-md-start text-center mt-md-0 mt-4'>
                                    <h2 className='ff-ember-rg'>5+ hours</h2>
                                    <h6 className='ff-ember-lt'>Average View time per day</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-5 col-11 text-md-start text-center">
                    <h1 className='ff-ember-lt'>Advertise your Brand on World's No.1 OTT platform.</h1>
                    <h5 className='ff-ember-lt'>Extend your Reach to a Multicultural Audience with our diversified Targeting Techniques and Affable Ad Options</h5>
                </div>
            </div>
            <div className="row mt-xl-5 mt-5 pt-5">
                <div className="col-12 text-center">
                    <h2 className="ff-ember-lt border-center">Exceed your Reach by displaying your Ads across all the Devices</h2>
                    <h5 className="ff-ember-lt">The more devices your ad plays in, the larger audience you cover.</h5>
                </div>
            </div>
            <div className="row mt-xl-5 mt-5 mb-5 pt-xl-5 pt-md-4 pt-0 align-items-center text-md-start text-center">
                <div className="col-md-5 col-11">
                    <h2 className='ff-ember-lt'>Extend your Presence to a Global Level</h2>
                    <h5 className='ff-ember-lt w-md-75 w-100 mb-5'>We Let you reach viewers from Diverse Ethnicities through a Single Platform</h5>
                    <div className="d-flex flex-row justify-content-start ps-md-0 ps-5 my-3">
                        <div className='me-5'>
                            <button className='btn btn-warning rounded-pill'>
                                <i className='bi bi-book display-6'/>
                            </button>
                        </div>
                        <div className='text-start'>
                            <h3 className='ff-ember-rg'>2 Million+</h3>
                            <h6 className='ff-ember-lt'>Unique Users</h6>
                        </div>
                    </div>
                    <div className="d-flex flex-row justify-content-start ps-md-0 ps-5 my-3">
                        <div className='me-5'>
                            <button className='btn btn-warning rounded-pill'>
                                <i className='bi bi-book display-6'/>
                            </button>
                        </div>
                        <div className='text-start'>
                            <h3 className='ff-ember-rg'>14+ Languages</h3>
                            <h6 className='ff-ember-lt'>Multicultural Users</h6>
                        </div>
                    </div>
                    <div className="d-flex flex-row justify-content-start ps-md-0 ps-5 my-3">
                        <div className='me-5'>
                            <button className='btn btn-warning rounded-pill'>
                                <i className='bi bi-book display-6'/>
                            </button>
                        </div>
                        <div className='text-start'>
                            <h3 className='ff-ember-rg'>90%</h3>
                            <h6 className='ff-ember-lt'>Affluent Audience</h6>
                        </div>
                    </div>
                </div>
                <div className="col-md-7 col-11">
                    <WorldMap/>
                </div>
            </div>
            <div className="row mt-xl-5 mt-5 pt-5 pt-md-3 pt-0 justify-content-between">
                <div className="col-11 text-center mb-4">
                    <h2 className="ff-ember-lt border-center">Exceed your Reach by displaying your Ads across all the Devices</h2>
                </div>
                <div className="col-xxl-2 col-lg-3 col-6 ad-with-us">
                    <div className="card">
                        <span className='text-waring'>01</span>
                    </div>
                    <h5 className="ff-ember-rg w-90 mx-auto">
                        Discuss your Requirement with us
                    </h5>
                </div>
                <div className="col-xxl-2 col-lg-3 col-6 ad-with-us">
                    <div className="card">
                        <span className='text-success'>02</span>
                    </div>
                    <h5 className="ff-ember-rg w-90 mx-auto">
                        Obtain a Customized Media Plan
                    </h5>
                </div>
                <div className="col-xxl-2 col-lg-3 col-6 ad-with-us">
                    <div className="card">
                        <span className='text-primary'>03</span>
                    </div>
                    <h5 className="ff-ember-rg w-90 mx-auto">
                        Send your Creatives or Videos
                    </h5>
                </div>
                <div className="col-xxl-2 col-lg-3 col-6 ad-with-us">
                    <div className="card">
                        <span className='text-danger'>04</span>
                    </div>
                    <h5 className="ff-ember-rg w-90 mx-auto">
                        Complete your payment
                    </h5>
                </div>
                <div className="col-11 text-center mt-4">
                    <button className='btn btn-primary btn-lg px-3 mt-4'  onClick={() => props.setIndex("pills-advertise-us-tab")}>Advertise with us</button>
                </div>
            </div>
            <div className="row mt-xl-5 mt-5 pt-xl-5 pt-md-3 pt-0 justify-content-lg-between justify-content-center mb-4">
                <div className='col-lg-5 col-11'>
                    <h3 className="ff-ember-rg mb-4">
                        Reach the right audience
                    </h3>
                    <h5 className="ff-ember-lt mb-4">Target your potential audience based on language, region and more</h5>
                    <a className="text-primary ff-ember-lt">Learn more ›</a>
                </div>
                <div className='col-lg-1 d-lg-block d-none h-auto text-center'>
                    <div className="vr h-100"></div>
                </div>
                <div className='col-lg-5 col-11 mt-lg-0 mt-4'>
                    <h3 className="ff-ember-rg mb-4">
                        Choose the right ad format
                    </h3>
                    <h5 className="ff-ember-lt mb-4">Drive awareness, increase customers and share your brand offers with the Right Ad Format</h5>
                    <a className="text-primary ff-ember-lt">Learn more ›</a>
                </div>
            </div>
        </React.Fragment>
    )
}

export default OverView;